import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-gradient-to-br from-sage-light to-beige-light">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0')`,
          }}
        />
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
          <div className="mb-8">
            <h1 className="text-6xl md:text-8xl font-title font-bold mb-4 tracking-tight logo-text">
              ACQUOLINA
            </h1>
            <p className="text-xl md:text-2xl font-body font-light tracking-wide logo-subtitle">
              Roberto Cattaneo
            </p>
          </div>
          <h2 className="text-2xl md:text-4xl font-title font-light mb-8 leading-relaxed text-center">
            <div className="flex flex-col items-center">
              <span>Gastronomia Artigianale a domicilio</span>
              <div className="my-4"></div>
              <span>Personal Chef</span>
            </div>
          </h2>
          <p className="text-lg md:text-xl font-body mb-12 max-w-2xl mx-auto leading-relaxed">
            Esperienze culinarie uniche attraverso piatti pronti di alta qualità e servizi personalizzati per i tuoi eventi

          </p>
        </div>
      </section>

      {/* Two Souls Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-sage-dark mb-4">
              Due Anime, Una Passione
            </h2>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              Acquolina nasce dall'unione di due mondi: la praticità della gastronomia 
              moderna e la cura di una cucina genuina di qualità
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {/* Gastronomia Card */}
            <div className="group relative overflow-hidden rounded-3xl bg-white shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div 
                className="h-64 bg-cover bg-center"
                style={{
                  backgroundImage: `url('/images/gastronomia-mission.jpg')`,
                  backgroundPosition: '50% 35%'}}
              />
              <div className="p-8">
                <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                  Gastronomia Artigianale a domicilio

                </h3>
                <p className="font-body text-neutral-600 mb-6">
                  Piatti pronti confezionati in atmosfera modificata, preparati con 
                  ingredienti selezionati e consegnati direttamente a casa tua.
                </p>
                <div className="flex flex-col gap-3">
                  <Link 
                    to="/gastronomia"
                    className="bg-sage-dark text-white px-6 py-3 rounded-full font-semibold text-center transition-all duration-300 transform hover:scale-105"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Scopri la Gastronomia
                  </Link>
                  <a 
                    href="https://48ig4en6nuwn8uwrecno4owo7qy6lua4.pwa.pienissimo.pro/home?hashform=48ig4en6nuwn8uwrecno4owo7qy6lua4"
                    className="border-2 border-sage-dark text-sage-dark hover:bg-sage-dark hover:text-white px-6 py-3 rounded-full font-semibold text-center transition-all duration-300 transform hover:scale-105"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ordina Ora
                  </a>
                </div>
              </div>
            </div>

            {/* Personal Chef Card */}
            <div className="group relative overflow-hidden rounded-3xl bg-white shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div 
                className="h-64 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1518619745898-93e765966dcd')`,
                }}
              />
              <div className="p-8">
                <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                  Personal Chef
                </h3>
                <p className="font-body text-neutral-600 mb-6">
                  Servizi personalizzati per eventi privati, cene esclusive e 
                  occasioni speciali. Ogni piatto racconta una storia.
                </p>
                <div className="flex flex-col gap-3">
                  <Link 
                    to="/personal-chef"
                    className="bg-sage-dark text-white px-6 py-3 rounded-full font-semibold text-center transition-all duration-300 transform hover:scale-105"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Scopri il Personal Chef
                  </Link>
                  <a 
                    href="https://wa.me/393458279163?text=Ciao, ho visto il tuo sito ACQUOLINA e vorrei maggiori informazioni sui tuoi servizi."
                    className="border-2 border-sage-dark text-sage-dark hover:bg-sage-dark hover:text-white px-6 py-3 rounded-full font-semibold text-center transition-all duration-300 transform hover:scale-105"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Scrivimi su WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-sage-dark text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-title font-bold mb-6">
            Pronto a Scoprire Acquolina?
          </h2>
          <p className="text-xl font-body mb-8 opacity-90">
            Inizia qui il tuo viaggio culinario. Ordina i miei piatti pronti 
            o richiedi un servizio personalizzato per il tuo evento.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://48ig4en6nuwn8uwrecno4owo7qy6lua4.pwa.pienissimo.pro/home?hashform=48ig4en6nuwn8uwrecno4owo7qy6lua4"
              className="bg-white text-sage-dark hover:bg-beige-light px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gastronomia
            </a>
            <Link 
              to="/personal-chef"
              className="border-2 border-white hover:bg-white hover:text-sage-dark px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              onClick={() => window.scrollTo(0, 0)}
            >
              Personal Chef
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;